document.addEventListener('DOMContentLoaded', function () {

  // SVG Injector to inject
  var mySVGsToInject = document.querySelectorAll('img.inject-svg');
  if (mySVGsToInject !== null) {
    SVGInjector(mySVGsToInject);
  }

  // Add underline on menu items with children
  var menuItems = document.getElementsByClassName('mm-listitem__btn');

  for (var i = 0; i < menuItems.length; i++) {
    menuItems[i].classList.remove('mm-btn', 'mm-btn_next');
  }
});

//Close
jQuery(document).ready(function () {
  var lang = document.documentElement.lang;

  jQuery('.phv__video-control').each(function () {
    jQuery(this).on("click", function () {
      var videoId = jQuery(this).attr("data-video-id");
      var videoElm = document.getElementById(videoId);
      if (jQuery(this).hasClass('play')) {
        jQuery(this).removeClass('play');
        jQuery(this).addClass('pause');
        jQuery(this).attr('aria-label', 'Pause');
        videoElm.pause();
      } else {
        jQuery(this).removeClass('pause');
        jQuery(this).addClass('play');
        if (lang === "fr") {
          jQuery(this).attr('aria-label', 'Jouer');
        } else {
          jQuery(this).attr('aria-label', 'Play');
        }
        videoElm.play();
      }
    });
  });
});


//News table
jQuery(document).ready(function () {
  if (jQuery('body').hasClass('node--type-news')) {
    jQuery('table').each(function () {
      jQuery(this).parent().addClass('table-responsive');
    });
  }
});


//Handle stop video
jQuery(document).ready(function () {
  let event = new Event("stopVideo")

  jQuery('.modal').each(function () {
    let videoEl = this.querySelector('lite-youtube');

    this.addEventListener('click', e => {
      let target = jQuery(e.target);
      if (target.hasClass('close') || target.closest('.close').length > 0 || target.hasClass('modal')) {
        videoEl.dispatchEvent(event);
      }
    })
  });
});

//Slick Slider
jQuery(document).ready(function () {
  jQuery('.paragraph--images-gallery').each(function () {

    var galleryId = jQuery(this).data('id');
    var galleryPager = jQuery(this).find('.pig__paging');

    jQuery(this).find('.pig__slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: 0,
      centerMode: true,
      fade: true,
      arrows: true,
      dots: false,
      dotsClass: 'pig__paging',
      asNavFor: '#images-gallery-nav-' + galleryId,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            arrows: false,
            dotsClass: 'slick-dots'
          }
        }
      ]
    });

    jQuery(this).find('.pig__navigation').slick({
      slidesToShow: 10,
      slidesToScroll: 1,
      asNavFor: '#images-gallery-' + galleryId,
      dots: false,
      focusOnSelect: true
    });

    jQuery(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      galleryPager.text(i + '/' + slick.slideCount);
    });
  });
});

jQuery(document).ready(function () {
  jQuery('.js-paragraph__publication-carousel').each(function () {

    let galleryId = jQuery(this).data('id');
    let galleryNbSlide = normalizeNb(parseInt(jQuery(this).data('nb-slide')));

    jQuery(this).find('.pc__slider').slick({
      infinite: false,
      slidesToShow: galleryNbSlide,
      slideToScroll: galleryNbSlide,
      arrows: false,
      dots: true,
      appendDots: jQuery(this).find('.pc__navigation-dots'),
      swipeToSlide: true,
      centerMode: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: normalizeNb(galleryNbSlide, 1),
            slideToScroll: normalizeNb(galleryNbSlide, 1),
          }
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: normalizeNb(galleryNbSlide, 2),
            slideToScroll: normalizeNb(galleryNbSlide, 2),
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

    jQuery(this).on('init reInit afterChange', function (event, slick, currentSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      let i = (currentSlide ? currentSlide : 0) + 1;
    });
  });
});

const normalizeNb = function (nb, substract = 0) {
  if (nb > 4) {
    nb = 4 - substract;
  } else if (nb === 0) {
    nb = 1;
  } else if ((nb - substract) > 1) {
    nb = nb - substract;
  }
  return nb;
};

// Cybermetrics
var _push_event_to_google = function (category, action, label) {
  dataLayer.push({
    event: "gaEvent",
    eventCategory: category,
    eventAction: action,
    eventLabel: label
  });
};

var pushDataLayerFormSubmitContactUs = function () {
  _push_event_to_google("Contact us", "Form submitted", "Contact us form");
};

var pushDataLayerFormSubmitNewsletter = function () {
  _push_event_to_google("Newsletter", "Subscription form submitted", undefined);
};

var pushDataLayerOnSiteSearch = function (results) {

  var facets = [];
  jQuery(".facet--active").each(function () {
    facets.push(jQuery(this).find("span.facet-item__value").text());
  });

  var searchKeywords = "No search keyword";
  var userAutocompleteUIInputValue = jQuery("input.ui-autocomplete-input").val();
  if (userAutocompleteUIInputValue != undefined && userAutocompleteUIInputValue.length > 0) {
    searchKeywords = userAutocompleteUIInputValue;
  }

  if (results > 0) {
    window.dataLayer.push({
      "event": "gaOnsiteSearch",
      "searchCase": "with-results",
      "searchCategory": facets.join(" - "),
      "searchKeywords": searchKeywords
    });
  } else if (results == 0) {
    window.dataLayer.push({
      "event": "gaOnsiteSearch",
      "searchCase": "without-results",
      "searchCategory": facets.join(" - "),
      "searchKeywords": searchKeywords
    });
  }
};

jQuery(document).ready(function () {

  // P&S Contact Intent
  jQuery(".dataLayerProductAndServicesContactIntent").on("click", function () {
    _push_event_to_google("Products and services", "Contact us button clicked", "Redirection to contact us page");
  });

  // Phone number clicked
  var defaultNodeTitle = jQuery("body").data("default-node-title");
  jQuery("body").on("click", "a[href*='tel:']", function () {
    _push_event_to_google("Cascades worldwide", "Phone number clicked", defaultNodeTitle);
  });

  jQuery(".dataLayerCascadesWorldwideGetDirections").on("click", function () {
    _push_event_to_google("Cascades worldwide", "Directions link clicked", defaultNodeTitle);
  });

  jQuery(".dataLayerCascadesWorldwideLocationDetailsView").on("click", function () {
    _push_event_to_google("Cascades worldwide", "Details page viewed", defaultNodeTitle);
  });
  // Geolocation - Details Link
  jQuery(".dataLayerCascadesWorldwideSeeDetailsClick").on("click", function () {
    _push_event_to_google("Cascades worldwide", "Details link clicked", jQuery(this).text());
  });

  // Top Navigation
  jQuery("a.mm-listitem__btn, a.mm-listitem__text").on("click", function () {

    var label = [jQuery(this).parent().find(".mm-listitem__text").clone().children().remove().end().text()];
    var menuLevelClassNamePrefix = "menu-level--";
    var currentMenuLevel = -1;
    jQuery(this).parents("ul.menu").attr("class").split(" ").forEach(function (className) {
      if (className.match("^" + menuLevelClassNamePrefix)) {
        currentMenuLevel = className.replace(menuLevelClassNamePrefix, "");
      }
    });
    if (currentMenuLevel > -1) {
      for (var i = currentMenuLevel - 1; i >= 0; i--) {
        label.unshift(jQuery("." + menuLevelClassNamePrefix + i).find(".mm-listitem_selected-parent > a.mm-listitem__text").clone().children().remove().end().text());
      }
      _push_event_to_google("Navigation menu", "Top navigation item clicked", label.join(" | "));
    }
  });

  // On-Site Search
  if (jQuery("body").hasClass("path-search")) {
    // Push on pageloading
    pushDataLayerOnSiteSearch(jQuery(this).find(".search-results").data("results"));
    // Push on search refined
    jQuery("body").on("DOMNodeInserted", ".search", function () {
      pushDataLayerOnSiteSearch(jQuery(this).find(".search-results").data("results"));
    });

    //focus on search field
    jQuery(this).find("#edit-text").focus();

    //Default behaviour when page load
    if (jQuery(this).find("#edit-text").val() == "") {
      jQuery(this).find(".search-no-result").addClass("d-none");
    } else {
      jQuery(this).find(".search-no-result").removeClass("d-none");
    }
  }
});

// CYBERMETRIE
// HTML5 Video cybermetrie
jQuery(document).ready(function () {
  jQuery('.ptv__video--html').each(function () {
    var vidTitle = jQuery(this).find('source').attr('src');
    var paused = false;
    this.addEventListener('ended', function () {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'gaEvent',
        'eventCategory': 'Video player',
        'eventAction': 'Video completed',
        'eventLabel': vidTitle
      });
    });
    this.addEventListener('play', function () {
      if (!paused) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          'event': 'gaEvent',
          'eventCategory': 'Video player',
          'eventAction': 'Video played',
          'eventLabel': vidTitle
        });
      }
    });

    this.addEventListener('pause', function () {
      paused = true;
    });
  });
});

// Anchors navigation z-index logic for mobile
jQuery(document).ready(function () {
  jQuery('.anchors-navigation').parents('.paragraph').parent().css({'position': 'relative', 'z-index': '2'});
});

(function ($, Drupal, once) {
  Drupal.behaviors.webformCybermetrie = {
    attach: function (context, settings) {
      // Form success
      $(once('webformCybermetrie', '.webform-confirmation')).each(function () {
        var $currentSubmission = $(this);
        var formCategory = $currentSubmission.data('webform');
        var submissionNumber = $currentSubmission.find('.sub-num').text();
        var submissionLength = submissionNumber.length;
        var defaultNumber = formCategory + '0000000';
        var finalConfirmationNumber = defaultNumber.slice(0, '-' + submissionLength) + submissionNumber;

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          'event': 'gaEvent',
          'eventCategory': 'Custom box',
          'eventAction': 'Form success',
          'eventLabel': 'Form : Leadgen - ' + getFormCategory(formCategory),
          'transactionID': finalConfirmationNumber
        });
      });

      // Form start + submit
      $(once('webformCybermetrie', '.webform-submission-form')).each(function () {
        var $currentForm = $(this);
        var formCategory = getFormCategory($currentForm.data('webform'));
        var firstClick = false;
        var isStarted = false;

        // Form start
        $currentForm.on('focusin', function () {
          if (isStarted === false) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              'event': 'gaEvent',
              'eventCategory': 'Custom box',
              'eventAction': 'Form start',
              'eventLabel': 'Form : Leadgen - ' + formCategory
            });

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              'event': 'gaEvent',
              'eventCategory': 'Products and services',
              'eventAction': 'Contact form started',
              'eventLabel': 'Form : Leadgen - ' + formCategory
            });

            isStarted = true;
          }
        });

        // Form submit
        $currentForm.on('click', '.webform-button--submit', function () {
          if (firstClick === false) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              'event': 'gaEvent',
              'eventCategory': 'Custom box',
              'eventAction': 'Form submit',
              'eventLabel': 'Form : Leadgen - ' + formCategory
            });

            firstClick = true;
          }
        });
      });

      // Function
      function getFormCategory(item) {
        if (item == 'BP') {
          return 'Custom Box';
        } else if (item == 'BE') {
          return 'Ready to ship';
        } else if (item == 'CG') {
          return 'Generic';
        } else {
          return 'Other';
        }
      }
    }
  };
})(jQuery, Drupal, once);

// Animation des ancres
document.addEventListener('DOMContentLoaded', function () {
  jQuery('a[href^="#"]').on('click', function () {
    var currentTarget = this.hash;
    var currentTargetPosition = jQuery(currentTarget).offset().top;
    var menu = jQuery('#navigation').outerHeight();
    var body = document.body;
    var docEl = document.documentElement;

    var clientTop = docEl.clientTop || body.clientTop || 90;

    var finalPosition = currentTargetPosition - clientTop - menu;
    jQuery('html, body').animate({
      scrollTop: finalPosition.toString() + 'px'
    }, 1000);
  });
});

// Touchscreen detection
document.addEventListener('DOMContentLoaded', function () {
  var isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));

  if (isTouch) {
    jQuery('html').addClass('touchscreen');
  }
});

// Flip card
document.addEventListener('DOMContentLoaded', function () {
  jQuery('.flip-card').on('mouseenter', function () {
    jQuery(this).addClass('active');
  });

  jQuery('.flip-card').on('mouseleave', function () {
    jQuery(this).removeClass('active');
  });

  jQuery('body').on('click', '.fc__close', function (e) {
    e.stopPropagation();
    jQuery(this).parents('.flip-card').removeClass('active');
  });

  if (jQuery('html').hasClass('touchscreen')) {
    jQuery('body').on('click', '.flip-card', function () {
      if (jQuery(this).hasClass('active')) {
        jQuery(this).removeClass('active');
      } else {
        jQuery(this).addClass('active');
      }
    });
  }

});

// Masonry - Livre d'or
document.addEventListener('DOMContentLoaded', function () {

// init Masonry
  var $grid = jQuery('.cards-masonry').masonry({
    itemSelector: '.card',
    columnWidth: '.card',
    gutter: 12
  });

// layout Masonry after each image loads
  $grid.imagesLoaded().progress(function () {
    $grid.masonry('layout');
  });
});

(function ($, Drupal, once) {
  Drupal.behaviors.events = {
    attach: function (context, settings) {
      $(document, context).ajaxSuccess(function (event, xhr, settings) {
        if (settings.url.search('view_name=webform_submissions&view_display_id=block_3')) {
          jQuery('.cards-masonry').masonry('reloadItems').masonry('layout');
          //fix layout issue when image not loaded
          setTimeout(
            function () {
              jQuery('.cards-masonry').masonry('reloadItems').masonry('layout');
            }, 1500);
        }
      });
    }
  };
})(jQuery, Drupal, once);

//event teaser animation
document.addEventListener('DOMContentLoaded', function () {

  var eventTeaserBtn = jQuery.find('.event-teaser_btn');
  // var eventTeaserCloseBtn = jQuery.find('.event-teaser_close-btn');
  var eventTeaserClose = jQuery.find('.event-teaser_close');
  var eventTeaserContent = jQuery.find('.event-teaser_content');

  function closeTeaser(teaser) {
    jQuery(teaser).animate(
      {
        opacity: '0'
      },
      500, function () {

        jQuery(teaser).css({
          display: 'none'
        });
        eventTeaserBtn[0].focus();
      });
  }

  function openTeaser(teaser) {
    jQuery(teaser).animate(
      {
        opacity: '1'
      },
      500, function () {
        eventTeaserClose[0].focus();
      });
  }

  if (!!eventTeaserBtn && !!eventTeaserContent) {

    if (jQuery(eventTeaserContent).hasClass('active')) {
      jQuery(eventTeaserContent).css({
        display: 'block'
      });
      jQuery(eventTeaserContent).removeClass('active');
      openTeaser(eventTeaserContent);
    }
    jQuery(eventTeaserBtn).click(function () {
      jQuery(eventTeaserContent).css({
        display: 'block'
      });
      openTeaser(eventTeaserContent);
    });
    jQuery(eventTeaserClose).click(function () {
      closeTeaser(eventTeaserContent);
    });
    jQuery(eventTeaserContent).click(function () {
      closeTeaser(eventTeaserContent);
    });
  }
});


//Animation
document.addEventListener('DOMContentLoaded', function () {
  var tileContainerEl = jQuery.find('.tiles-expand-container');
  //if single tile
  if (jQuery(tileContainerEl).hasClass('tiles-expand-single')) {
    var tileElem = jQuery(this).find('.tile__expand');
    var closeElem = jQuery(this).find('.tile__expand-close');
    var backElem = jQuery(this).find('.tile__expand-more-info');
    jQuery(tileElem).on("click", function () {
      closeElem.focus();
      if (jQuery(tileElem).hasClass('active')) {
        jQuery(tileElem).removeClass('active');
        jQuery(backElem).animate(
          {
            width: 0,
            height: 0,
            opacity: 0
          },
          600, function () {
            jQuery(backElem).css({
              display: 'none'
            });
          });
      } else {
        jQuery(this).addClass('active');
        jQuery(backElem).css({
          display: 'block'
        });
        jQuery(backElem).animate({
          width: '100%',
          height: '100%',
          opacity: '1'
        }, 600);
      }
    });
  } else {
    jQuery('.tile__expand').each(function () {
      var tileElem = jQuery(this).find('.tile__expand-front');
      var tileFeaturedInfo = jQuery(this).find('.tile__expand-front-featured');
      var tileMoreInfo = jQuery(this).find('.tile__expand-front-more-info');
      var closeElem = jQuery(this).find('.tile__expand-close');
      var moreInfoElem = jQuery(this).find('.tile__expand-open');
      var TileCurrent = this;
      jQuery(closeElem).on("click", function () {
        if (jQuery(TileCurrent).hasClass('active')) {
          jQuery(tileMoreInfo).css({
            display: 'none',
          });
          jQuery(tileFeaturedInfo).animate(
            {
              opacity: '1',
            },
            500);
          jQuery(tileMoreInfo).animate(
            {
              opacity: '0',
            },
            500);

          jQuery(tileElem).animate(
            {
              width: jQuery(TileCurrent).width(),
              height: jQuery(TileCurrent).height(),
            },
            500, function () {
              jQuery(TileCurrent).removeClass('active');
              jQuery(tileElem).removeClass('position-absolute');
              jQuery(tileElem).css({
                width: '100%',
                height: '100%',
              });
              moreInfoElem.focus();
            });
        }
      });
      jQuery(this).on("click", function () {
        if (!jQuery(this).hasClass('active')) {
          jQuery(tileMoreInfo).css({
            display: 'flex',
          });
          jQuery(tileFeaturedInfo).animate(
            {
              opacity: '0',
            },
            500);
          jQuery(tileMoreInfo).animate(
            {
              opacity: '1'
            },
            500);
          jQuery(this).addClass('active');
          var tileWidth = jQuery(this).width() / jQuery(this).parent().width() * 100;
          if (tileWidth < 100) {
            jQuery(tileElem).css({
              width: jQuery(this).width(),
              height: jQuery(this).height(),
            });
            jQuery(tileElem).addClass('position-absolute');
            jQuery(tileElem).animate({
              'width': '100%',
              'height': '100%',
            }, 500, function () {
              closeElem.focus();
            });
          }
        }
      });
    });
  }
});

//Change section by pagination number
//Change pagination
//John (2023-02)
function changeSectionByNumber(carousel, goToPagination, paginations, activePaginationElement) {
  var currentItem = carousel.querySelector('.carousel-item-section.c__mobile');
  var currentItemList = currentItem.querySelectorAll('.carousel-item');
  var activeItem = currentItem.querySelector('.show');


  for (var x = 0; x < paginations.length; x++) {
    paginations[x].classList.remove('active');
  }
  activePaginationElement.classList.add('active');


  if (parseInt(activePaginationElement.dataset.slideTo) == goToPagination) {
    for (var i = 0; i < currentItemList.length; i++) {
      currentItemList[i].classList.remove('left');
      currentItemList[i].classList.remove('show');
    }
    activeItem.classList.add('left');
    activeItem.classList.remove('show');
    currentItemList[goToPagination].classList.remove('left');
    currentItemList[goToPagination].classList.add('show');
  }
}

//Update pagination for changeSection
//John (2023-02)
function updatePagination(paginations, direction, carousel) {
  var currentItem = carousel.querySelector('.carousel-item-section.c__mobile');
  var currentItemList = currentItem.querySelectorAll('.carousel-item');
  var activeItem = currentItem.querySelector('.show');

  paginations.forEach(function (pagination) {
    pagination.classList.remove('active');
  });
  if (direction === 'next') {
    if ((parseInt(activeItem.id) + 1) < currentItemList.length) {
      paginations[parseInt(activeItem.id) + 1].classList.add('active');
    } else {
      paginations[0].classList.add('active');
    }
  } else if (direction === 'prev') {
    if ((parseInt(activeItem.id) - 1) >= 0) {
      paginations[parseInt(activeItem.id) - 1].classList.add('active');
    } else {
      paginations[currentItemList.length - 1].classList.add('active');
    }

  }
}

//carousel custom js since normal bootstrap JS does not support these functionalities:
function changeSection(type, direction) {
  var currentCarousel = document.querySelector('.tab-pane.active');
  var currentItem = currentCarousel.querySelector('.carousel-item-section' + '.' + type);
  var currentItemList = currentItem.querySelectorAll('.carousel-item');
  var activeItem = currentItem.querySelector('.show');

  switch (direction) {
    case 'next':
      if ((parseInt(activeItem.id) + 1) < currentItemList.length) {
        for (var i = 0; i < currentItemList.length; i++) {
          currentItemList[i].classList.remove('left');
        }
        activeItem.classList.add('left');
        activeItem.classList.remove('show');
        currentItemList[parseInt(activeItem.id) + 1].classList.remove('left');
        currentItemList[parseInt(activeItem.id) + 1].classList.add('show');
      } else {
        for (var j = 0; j < currentItemList.length; j++) {
          currentItemList[j].classList.remove('left');
        }
        activeItem.classList.remove('show');
        currentItemList[0].classList.add('show');
      }
      break;

    case 'prev':
      if ((parseInt(activeItem.id) - 1) >= 0) {
        activeItem.classList.remove('show');
        currentItemList[parseInt(activeItem.id) - 1].classList.add('show');
        currentItemList[parseInt(activeItem.id) - 1].classList.remove('left');
        if ((parseInt(activeItem.id) - 2) >= 0) {
          currentItemList[parseInt(activeItem.id) - 2].classList.add('left');
        } else {
          currentItemList[currentItemList.length - 1].classList.add('left');
        }
      } else {
        activeItem.classList.remove('show');
        for (var k = 0; k < currentItemList.length; k++) {
          currentItemList[k].classList.add('left');
        }
        currentItemList[currentItemList.length - 1].classList.add('show');
        currentItemList[currentItemList.length - 1].classList.remove('left');
      }
      break;
  }
}

//Article anchor list .active script
function createArticleAnchorListItems() {
  let selectors = document.querySelectorAll('.js-article__anchor-list__item-link');
  if (selectors.length > 0) {
    selectors.forEach((selector) => {
      selector.addEventListener('click', () => {
        let currentSelected = selector.dataset.href;
        selectors.forEach((xselector) => {
          if (xselector.dataset.href === currentSelected) {
            xselector.classList.add('active');
          } else {
            xselector.classList.remove('active');
          }
        });

      });

    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  "use strict";
  createArticleAnchorListItems();
});

function openWindow(link, newTab) {
  if (newTab) {
    window.open(link);
  } else window.open(link, "_self");
}
